module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/cargue-masivo/cargue-masivo.component.css
// module id = ./src/app/cargue-masivo/cargue-masivo.component.css
// module chunks = main